module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/features.svg?3c3db239";